<div class="department-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Engineering Department</span>
          <h1>{{ departmentName }}</h1>
          <p>
            Building future-ready cyber security professionals through secure
            computing fundamentals, practical defense skills, ethical practices,
            and industry-oriented learning.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Established</span>
            <strong>{{ establishedYear }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Intake</span>
            <strong>{{ intake }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Programme</span>
            <strong>{{ programmeSummary }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Contact</span>
            <strong>{{ contactEmail }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Department Menu</span>
          <h2>{{ departmentName }}</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Academic Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Cyber Security, Fatima Michael College of Engineering
            &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/page-title12.jpg"
                  alt="Department of Cyber Security"
                />
              </div>

              <div class="section-copy">
                <h3>About the Department</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let fact of quickFacts">
                <span class="fact-title">{{ fact.title }}</span>
                <p>{{ fact.value }}</p>
              </article>
            </section>
          </ng-container>

          <!-- Vision & Mission -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="info-grid">
              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/vision-icon.png" alt="Vision" />
                </div>
                <h3>Our Vision</h3>
                <p>{{ visionText }}</p>
              </article>

              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/mission-icon.png" alt="Mission" />
                </div>
                <h3>Our Mission</h3>
                <div class="stack-list">
                  <p *ngFor="let item of missionPoints">
                    {{ item }}
                  </p>
                </div>
              </article>
            </section>
          </ng-container>

          <!-- PEO -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Educational Objectives (PEO)</h3>
                <p>
                  Broad academic, professional, and lifelong learning outcomes
                  expected from graduates.
                </p>
              </div>

              <div class="numbered-list">
                <article class="number-card" *ngFor="let peo of peos; let i = index">
                  <div class="number-badge">{{ i + 1 }}</div>
                  <p>{{ peo }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- POs & PSOs -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Outcomes (POs)</h3>
                <p>
                  Knowledge, skills, ethics, and professional capabilities expected
                  from graduates of the programme.
                </p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Program Specific Outcomes (PSOs)</h3>
                <p>
                  Department-specific competencies developed through Cyber Security.
                </p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programSpecificOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Programme Offered -->
          <ng-container *ngSwitchCase="'tab14'">
            <section class="content-card">
              <div class="section-head">
                <h3>Programmes Offered</h3>
                <p>Current academic programme details under the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Programme Name</th>
                      <th>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let programme of programmes">
                      <td>{{ programme.sno }}</td>
                      <td>{{ programme.name }}</td>
                      <td>{{ programme.duration }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Laboratory Facilities -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Laboratory Facilities</h3>
                <p>
                  Practical learning spaces supporting cyber defense, secure system
                  design, digital investigation, cryptography, and network protection.
                </p>
              </div>

              <ng-container *ngIf="labs.length > 0; else noLabData">
                <div class="lab-grid">
                  <article class="lab-card" *ngFor="let lab of labs">
                    <div class="lab-media">
                      <img [src]="lab.image" [alt]="lab.title" />
                    </div>
                    <div class="lab-body">
                      <h4>{{ lab.title }}</h4>
                      <p>{{ lab.description }}</p>
                    </div>
                  </article>
                </div>
              </ng-container>

              <ng-template #noLabData>
                <div class="section-copy">
                  <p>Laboratory facility details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Association Activities -->
     <ng-container *ngSwitchCase="'tab6'">
  <section class="content-card">
    <div class="section-head">
      <h3>Association Activities</h3>
      <p>
        Student association events, technical activities, seminars,
        workshops, and departmental engagement initiatives.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Activity</th>
            <th>Date</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of associationDetailRecords">
            <td>{{ item.sno }}</td>
            <td>{{ item.activity }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="lab-grid" *ngIf="associationPhotos.length > 0">
      <article class="lab-card" *ngFor="let item of associationPhotos">
        <div class="lab-media">
          <img [src]="item.image" [alt]="item.caption" />
        </div>
        <div class="lab-body">
          <h4>{{ item.caption }}</h4>
          
        </div>
      </article>
    </div>
  </section>
</ng-container>

          <!-- MoUs -->
   <ng-container *ngSwitchCase="'tab7'">
  <section class="content-card">
    <div class="section-head">
      <h3>MoU's</h3>
      <p>
        Collaborations supporting student development, training, internship,
        and research engagement.
      </p>
    </div>

    <ng-container *ngIf="mous.length > 0; else noMouData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Organization</th>
              <th>Date of Signing</th>
              <th>Purpose</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of mous">
              <td>{{ item.sno }}</td>
              <td>{{ item.organization }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.purpose }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lab-grid" *ngIf="mouPhotos.length > 0">
        <article class="lab-card" *ngFor="let item of mouPhotos">
          <div class="lab-media">
            <img [src]="item.image" [alt]="item.caption" />
          </div>
          <div class="lab-body">
            <h4>{{ item.caption }}</h4>
            
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noMouData>
      <div class="section-copy">
        <p>MoU details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

          <!-- Placement Record -->
          <ng-container *ngSwitchCase="'tab8'">
            <section class="content-card">
              <div class="section-head">
                <h3>Placement Record</h3>
                <p>Selected placement outcomes of students from the department.</p>
              </div>

              <ng-container *ngIf="placementRecords.length > 0; else noPlacementTable">
                <div class="table-wrap">
                  <table class="info-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Batch</th>
                        <th>Name</th>
                        <th>Designation</th>
                        <th>Company Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of placementRecords">
                        <td>{{ item.sno }}</td>
                        <td>{{ item.batch || '-' }}</td>
                        <td>{{ item.studentName }}</td>
                        <td>{{ item.designation }}</td>
                        <td>{{ item.companyName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>

              <ng-template #noPlacementTable>
                <div class="section-copy">
                  <p>Student-wise placement details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Industrial Visit -->
          <ng-container *ngSwitchCase="'tab9'">
            <section class="content-card">
              <div class="section-head">
                <h3>Industrial Visit</h3>
                <p>
                  Industrial exposure visits that support practical learning and
                  real-world cyber security understanding.
                </p>
              </div>

              <ng-container *ngIf="industrialVisits.length > 0; else noIndustrialVisitData">
                <div class="lab-grid">
                  <article class="lab-card" *ngFor="let visit of industrialVisits">
                    <div class="lab-media">
                      <img [src]="visit.image || visit.images?.[0]" [alt]="visit.title" />
                    </div>

                    <div class="lab-body">
                      <h4>{{ visit.title }}</h4>
                      <p>{{ visit.description }}</p>
                    </div>
                  </article>
                </div>
              </ng-container>

              <ng-template #noIndustrialVisitData>
                <div class="section-copy">
                  <p>Industrial visit details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Value Added Courses -->
     <ng-container *ngSwitchCase="'tab10'">
  <section class="content-card">
    <div class="section-head">
      <h3>Value Added Courses</h3>
      <p>
        Additional training programmes that enhance technical and
        professional readiness.
      </p>
    </div>

    <ng-container *ngIf="valueAddedCourses.length > 0; else noValueAddedData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Course Name</th>
              <th>Duration</th>
              <th>Company Name</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of valueAddedCourses">
              <td>{{ item.sno }}</td>
              <td>{{ item.courseName }}</td>
              <td>{{ item.duration }}</td>
              <td>{{ item.companyName }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lab-grid" *ngIf="valueAddedCoursePhotos.length > 0">
        <article class="lab-card" *ngFor="let item of valueAddedCoursePhotos">
          <div class="lab-media">
            <img [src]="item.image" [alt]="item.caption" />
          </div>
          <div class="lab-body">
            <h4>{{ item.caption }}</h4>
            
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noValueAddedData>
      <div class="section-copy">
        
      </div>
    </ng-template>
  </section>
</ng-container>
          <!-- Alumni -->
          <ng-container *ngSwitchCase="'tab11'">
            <section class="content-card">
              <div class="section-head">
                <h3>Alumni</h3>
                <p>Distinguished alumni from the department.</p>
              </div>

              <ng-container *ngIf="alumniRecords.length > 0; else noAlumniData">
                <div class="lab-grid">
                  <article class="lab-card" *ngFor="let alumni of alumniRecords">
                    <div class="lab-media">
                      <img [src]="alumni.image" [alt]="alumni.name" />
                    </div>

                    <div class="lab-body">
                      <h4>{{ alumni.name }}</h4>
                      <p><strong>Batch:</strong> {{ alumni.batch }}</p>
                      <p>{{ alumni.role }}</p>
                      <p>{{ alumni.company }}</p>
                      <p>{{ alumni.quote }}</p>
                    </div>
                  </article>
                </div>
              </ng-container>

              <ng-template #noAlumniData>
                <div class="section-copy">
                  <p>Alumni details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Achievements -->
      <ng-container *ngSwitchCase="'tab12'">
  <section class="content-card">
    <div class="section-head">
      <h3>Achievements</h3>
      <p>Student and departmental achievements will be listed here.</p>
    </div>

    <ng-container *ngIf="achievements.length > 0; else noAchievementData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Achiever</th>
              <th>Event</th>
              <th>Organizer</th>
              <th>Level</th>
              <th>Date</th>
              <th>Award</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of achievements">
              <td>{{ item.sno }}</td>
              <td>{{ item.achiever }}</td>
              <td>{{ item.eventName }}</td>
              <td>{{ item.organizer }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.award }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lab-grid" *ngIf="achievementPhotos.length > 0">
        <article class="lab-card" *ngFor="let item of achievementPhotos">
          <div class="lab-media">
            <img [src]="item.image" [alt]="item.caption" />
          </div>
          <div class="lab-body">
            <h4>{{ item.caption }}</h4>
            
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noAchievementData>
      <div class="section-copy">
        <p>Achievement details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

          <!-- NPTEL -->
          <ng-container *ngSwitchCase="'tab13'">
            <section class="content-card">
              <div class="section-head">
                <h3>NPTEL</h3>
                <p>Faculty NPTEL certification details.</p>
              </div>

              <ng-container *ngIf="nptelRecords.length > 0; else noNptelData">
                <div class="table-wrap">
                  <table class="info-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name of the Faculty</th>
                        <th>Subject</th>
                        <th>Grade</th>
                        <th>Session</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of nptelRecords; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.staffName }}</td>
                        <td>{{ item.subject }}</td>
                        <td>{{ item.grade }}</td>
                        <td>{{ item.session }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>

              <ng-template #noNptelData>
                <div class="section-copy">
                  <p>NPTEL details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Research -->
          <ng-container *ngSwitchCase="'tab15'">
            <section class="content-card">
              <div class="section-head">
                <h3>FDP</h3>
                <p>Faculty Development Programme participation details.</p>
              </div>

              <ng-container *ngIf="fdpRecords.length > 0; else noFdpData">
                <div class="table-wrap">
                  <table class="info-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name of the Staff</th>
                        <th>Title</th>
                        <th>College Name</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of fdpRecords">
                        <td>{{ item.sno }}</td>
                        <td>{{ item.staffName }}</td>
                        <td>{{ item.title }}</td>
                        <td>{{ item.collegeName }}</td>
                        <td>{{ item.date }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>

              <ng-template #noFdpData>
                <div class="section-copy">
                  
                </div>
              </ng-template>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Conference</h3>
                <p>
                  Conference publications and paper presentations by faculty members
                  of the department.
                </p>
              </div>

              <ng-container *ngIf="conferenceRecords.length > 0; else noConferenceData">
                <div class="table-wrap">
                  <table class="info-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Event</th>
                        <th>Name of the Participant</th>
                        <th>Date</th>
                        <th>College Name</th>
                        <th>Title</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of conferenceRecords">
                        <td>{{ item.sno }}</td>
                        <td>{{ item.conferenceName }}</td>
                        <td>
                          <div *ngFor="let author of item.authors">
                            {{ author }}
                          </div>
                        </td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.collegeName }}</td>
                        <td>{{ item.paperTitle }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>

              <ng-template #noConferenceData>
                <div class="section-copy">
                  
                </div>
              </ng-template>
            </section>
          </ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Head of the Department,<br />
          Department of Cyber Security,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" [href]="'mailto:' + contactEmail">
          {{ contactEmail }}
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Admissions</span>
        <h3>Welcome to Department of Cyber Security</h3>
        <p>
          Build your future in secure computing, cyber defense, ethical hacking,
          and digital investigation.
        </p>
        <a class="apply-button" routerLink="/inquiry">
          Apply Now
        </a>
      </article>
    </section>
  </div>
</div>